import {

    CREATE_RESERVATION_REQUEST,
    CREATE_RESERVATION_SUCCESS,
    CREATE_RESERVATION_FAIL,
    CREATE_RESERVATION_RESET,

    UPDATE_RESERVATION_STATUS_REQUEST,
    UPDATE_RESERVATION_STATUS_SUCCESS,
    UPDATE_RESERVATION_STATUS_RESET,
    UPDATE_RESERVATION_STATUS_FAIL,


    ALL_RESERVATIONS_REQUEST,
    ALL_RESERVATIONS_SUCCESS,
    ALL_RESERVATIONS_FAIL,


    SINGLE_RESERVATION_REQUEST,
    SINGLE_RESERVATION_SUCCESS,
    SINGLE_RESERVATION_FAIL,



    CLEAR_ERRORS
} from "../constants/reservationConstants";


import {
  BLOCK_PRODUCT_REQUEST,
  BLOCK_PRODUCT_SUCCESS,
  BLOCK_PRODUCT_FAIL,
  BLOCK_PRODUCT_RESET
} from "../constants/productConstants";


export const createReservationReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_RESERVATION_REQUEST:
        case UPDATE_RESERVATION_STATUS_REQUEST:
        case BLOCK_PRODUCT_REQUEST:
            return {
                ...state,
                loading: true
            };

        case CREATE_RESERVATION_SUCCESS:
        case UPDATE_RESERVATION_STATUS_SUCCESS:
        case BLOCK_PRODUCT_SUCCESS:
            return {
                loading: false,
                success: true,
                message: action.payload
            };

        case CREATE_RESERVATION_FAIL:
        case UPDATE_RESERVATION_STATUS_FAIL:
        case BLOCK_PRODUCT_FAIL:
            return {
                loading: false,
                error: action.payload,
            };

        case CREATE_RESERVATION_RESET:
        case UPDATE_RESERVATION_STATUS_RESET:
        case BLOCK_PRODUCT_RESET:
            return {
                ...state,
                loading: false,
                message: null
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null
            };

        default:
            return state;
    }
};

export const allReservationsReducer = (state = {}, action) => {
    switch (action.type) {
        case ALL_RESERVATIONS_REQUEST:
            return {
                ...state,
                loading: true
            };

        case ALL_RESERVATIONS_SUCCESS:
            return {
                loading: false,
                success: true,
                reservations: action.payload.reservations,
                totalReservations: action.payload.totalReservations,
                totalPages: action.payload.totalPages,
            };

        case ALL_RESERVATIONS_FAIL:
            return {
                loading: false,
                error: action.payload,
            };


        case CLEAR_ERRORS:
            return {
                ...state,
                error: null
            };

        default:
            return state;
    }
};


export const singleReservationReducer = (state = { reservation: {} }, action) => {

    switch (action.type) {
        case SINGLE_RESERVATION_REQUEST:
            return {
                loading: true,
            };

        case SINGLE_RESERVATION_SUCCESS:
            return {
                ...state,
                loading: false,
                reservation: action.payload.reservation,
            };

        case SINGLE_RESERVATION_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                reservation: null
            };
        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };

        default:
            return state;
    }
};
